import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Device } from 'app/models/device.model';
import { ShiftContainer } from 'app/models/shift.model';
import { ShiftService } from 'app/services/shift.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ShiftListComponent } from '../shift-list/shift-list.component';
export interface DialogData {
    deviceList: Array<Device>;
    changeDevice: Device;
}
@Component({
    selector: 'app-shift-container-list',
    templateUrl: './shift-container-list.component.html',
    styleUrls: ['./shift-container-list.component.scss']
})

export class ShiftContainerListComponent implements OnInit {
    public containerList: Array<ShiftContainer>

    constructor(
        public dialogRef: MatDialogRef<ShiftListComponent>,
        private _spinner: NgxSpinnerService,
        private _shiftService: ShiftService,
        @Inject(MAT_DIALOG_DATA) public data
    ) {

    }

    async ngOnInit() {
        try {
            this._spinner.show('loading');
            this.containerList = await this._shiftService.getContainerByShift(this.data);
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);

        }

    }
}